module.exports = __webpack_public_path__ + "static/media/smallRight.184bd81e.svg";